import React from 'react';
import { makeStyles, Typography, Button } from '@material-ui/core';
import bgImage from '../images/pexels-helena-lopes-2017802.jpg';
import { Link } from 'react-router-dom';



const Banner = () => {
  const classes = useStyles();

	return (
	<div className={classes.root}>
		<div className={classes.info}>
			<Typography variant="h2">
				Plan your Getaway ...
			</Typography>
      <Link to="search">
        <Button variant="contained">Checkout rooms</Button>
      </Link>
		</div>
	</div>
);
}

const useStyles = makeStyles((theme) => ({
  root: {
  	height: "50vh",
  	position: "relative",
  	backgroundImage: `url(${bgImage})`,
  	backgroundPosition: "center",
  	backgroundSize: "cover",
  	backgroundRepeat: "no-repeat",
  	objetFit: "contain",

  },
  info: {
  	backgroundColor: "rgba(31,31,31,.5)",
  	color: "#fefefe",
  	width: "350px",
  	padding: theme.spacing(3),
  	"& h2" : {
  		marginBottom: theme.spacing(4),
  	},
  	"& button" : {
  		backgroundColor: "rgba(255,120,31,.8)",
  		color: "#fff",
  		textTransform: "inherit",
  		fontSize: "1.2rem",
  		fontWeight: "bold",
  	},
  	"& button:hover" : {
  		backgroundColor: "#fefefe",
  		color: "rgba(255,120,31,.8)",
  	}
  }
}));

export default Banner